<template>
  <img v-if="imageSrc" :src="imageSrc" />
  <span v-else>{{ fio && fio[0] }}</span>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop(String) fio!: string;
  imageSrc: string | null = null;
}
</script>
<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
* {
  @include ava(101px);
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  * {
    @include avaSmall(63px);
  }
}
</style>